export default __webpack_public_path__ + "static/media/hero-girl-hugging-dog.a10a0baf.jpg";